import { formatPhoneNumber } from "@/core/utils/phone";
import { CustomerStatus, BaseCustomer } from "./customer";

export const getCustomerNameAndPhone = (customer?: BaseCustomer | null) =>
  customer?.name
    ? `${customer.name} · ${formatPhoneNumber(customer.phone_number)}`
    : formatPhoneNumber(customer?.phone_number);

export const getCustomerNameOrPhone = (customer?: BaseCustomer | null) =>
  customer?.name || formatPhoneNumber(customer?.phone_number) || "–";

export const getEnrichedCustomer = (customer: BaseCustomer) => ({
  ...customer,
  status: customer.status.toUpperCase() as CustomerStatus,
});
